import { useQuery } from "@apollo/client";

import { type MetricField } from "../../gql-generated/types";
import { type ApolloResult } from "../../shared/models";
import { type GetTopLensesQuery, type GetTopLensesQueryVariables, getTopLenses } from "../api/queries";
import { generateFieldsList } from "../generators";
import { type LensGranularity } from "../models";

import { useReportingGranularity } from "./useReportingGranularity";

interface UseTopLensesParams {
    metricField: MetricField;
    limit?: number;
    defaultRange?: LensGranularity;
}

export const useTopLenses = ({
    metricField,
    limit,
    defaultRange,
}: UseTopLensesParams): ApolloResult<{
    topLenses: GetTopLensesQuery | undefined;
}> => {
    const { startTime, endTime, selectedGranularity } = useReportingGranularity({ defaultRange });

    const { data, error, loading } = useQuery<GetTopLensesQuery, GetTopLensesQueryVariables>(getTopLenses, {
        variables: {
            granularity: selectedGranularity,
            startTime,
            endTime,
            sortBy: metricField,
            fieldsList: generateFieldsList([metricField]),
            limit,
        },
    });

    return {
        topLenses: data,
        error,
        loading,
    };
};
